import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Vehicule} from "./Vehicule";

// Constructor
export class GameAWalker extends Vehicule {

  constructor(id, index, game, startsHidden) {
    super(id, index, game);

    this.type = "walkers";

    this.speed = 0.5;
    this.bicycleMovingSpeed = -6;
    this.currentSpeed = this.speed;
    this.targetSpeed = this.speed;

    this.floatingRange = 1;
    this.scalingRange = {min: 2, max: 2}; // not working as expected so leave as same value for both

    this.rightLimit = this.game.appWidth + 60;
    this.leftLimit = -60;

    this.posYRange = {min: 370, max: 390}; // from bottom

    this.spawn(startsHidden);
  }

  getRandomTexture() {
    return "walker-" + window.getRandomInt(1, 7);
  }

}
